// 資產卡片組件
export default {
  // 標題
  totalAssetBalance: "總資產餘額",

  // 提示信息
  balanceDescription:
    "地址總資產餘額是根據本系統已收錄的幣種價值，按地址持有的所有主幣和代幣折算USDT的總餘額",
  systemSupport: "系統當前已支持",
  currencyCount: "317個幣種",

  // 單位
  usdtUnit: "USDT",
};
